import { autocompleteJobSearch } from './project-review/all';

import soxKendoPanelBar from './dashboards/sox/sox';

export default function() {
  if ($('.pannelbar--soxstatus').length) soxKendoPanelBar($('.pannelbar--soxstatus'));
    
  // Project Review Calls
  autocompleteJobSearch();
    
  // Popup
    
  $('.kendo-popup').each(function(index) {
    const $elPopup = $(this);
    const $elPopupToggle = $elPopup.find('.kendo-popup__toggle');
    const $elPopupContent = $elPopup.find('.kendo-popup__content');
    $elPopupContent.kendoPopup({
      anchor: $elPopupToggle,
      origin: 'bottom left',
      collision: 'fit'
    });
    
    $elPopupToggle.click(function() {
      $elPopupContent.data('kendoPopup').toggle();
    });
  });
}
